










































import { Component, Vue } from 'vue-property-decorator'
import { Device } from '@/interfaces/device.interface'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
library.add(faCopy)

import vel from 'vue-element-loading'

@Component({
  components: {
    FontAwesomeIcon,
    vel
  }
})
export default class DeviceList extends Vue {
  public devices: Device[] = []
  public clipboardIcon: any = faCopy
  public msisdn: string = '77061112233'

  // noinspection JSUnusedLocalSymbols
  public created(): void {
    if (this.$route.params.devices && this.$route.params.devices.length > 0) {
      this.devices = (this.$route.params as any).devices
    }
    if (this.$route.params.msisdn) {
      this.msisdn = this.$route.params.msisdn
    }
  }

  public mounted(): void {
    document.querySelector('body')!.classList.remove('no-scroll')
  }

  // noinspection JSUnusedLocalSymbols
  private copy(imei: string) {
    this.$copyText(imei).then(() => {
      this.$bvToast.toast('IMEI успешно скопирован', {
        autoHideDelay: 1000,
        variant: 'success'
      })
    })
  }
}
